import React, { ReactElement } from 'react'
import { Card } from 'ktr-materialui-react';
import {  makeStyles, Grid } from '@material-ui/core';
import { useRouteMatch, Route, Switch } from 'react-router-dom';
import SelfCentering from './SelfCentering';
import NotSelfCentering from './NotSelfCentering';
import { useIntl } from 'react-intl';
import Selfcentered from '../../images/selfcentered.png';
import NotSelfcentered from '../../images/not_selfcentered.png';


const useStyle = makeStyles({
    cardLeft: {
        marginRight: "20px"
    },
    cardRight: {
        marginLeft: "20px",
    },
    heading: {

    },
    card: {
        width: "240px",
        height: "320px",
        margin: "10px"
    }
});

export default function InternalClampingset(): ReactElement {
    const classes = useStyle();
    let { path, url } = useRouteMatch();
    const { formatMessage: f } = useIntl();

    function openLink(url: string) {
        const link = document.createElement('a');
        link.target = '_self';
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    return (
        <React.Fragment>
              <h2>{f({id: 'app.centered.heading'})}</h2>
            <Grid container style={{ marginTop: "20px" }} justify="center">
                <Grid item>
                    <Card className={classes.card}
                        heading={f({id:'app.selfcentered'})}
                        content={f({id:'app.selfcentered.text'})}
                        buttonText={f({ id: 'app.btn.forward' })}
                        imageURL={Selfcentered}
                        onClick={(event) => openLink("#" + url + "/selfcentering")}
                    />
                </Grid>

                <Grid item >
                    <Card heading={f({id:'app.notselfcentered'})}
                        content={f({id:'app.notselfcentered.text'})}
                        className={classes.card}
                        buttonText={f({ id: 'app.btn.forward' })}
                        imageURL={NotSelfcentered}
                        onClick={(event) => openLink("#" + url + "/notselfcentering")}
                    />
                </Grid>
            </Grid>
            <Switch>
                <Route path={`${path}/selfcentering`} component={SelfCentering}></Route>
                <Route path={`${path}/notselfcentering`} component={NotSelfCentering}></Route>
            </Switch>
        </React.Fragment>
    )
}
